import { put, call } from 'redux-saga/effects';
import * as actions from '../actions/incoming';
import { post, get } from '../../utils/api';
import { errorModalOpen } from '../../utils/functions';

export function* incoming({ payload }) {
  try {
    const response = yield call(post,
      '/grid/data/incoming/',
      {
        dateFrom: payload.dateFrom,
        dateTo: payload.dateTo,
        filter: payload.filter,
        plantId: payload.plantId,
        items: payload.items
      });
    // todo убрать комитт
    yield put(actions.getIncomingSuccess(
      response && response.length
        ? response
          .filter((item) => !item.mcNumId)
          .map((item) => ({
            ...item,
            commonNumber: `${(item.heatId === null)
              ? ''
              : item.heatId}-${item.cgId}-${item.actualPieceId}`,
            sizes: `${(item.thick === null)
              ? ''
              : item.thick}x${(item.width === null)
              ? ''
              : item.width}`,
            // eslint-disable-next-line no-nested-ternary
            azhStatusDescr: `${(item.mh3DocStatusDescr === null)
              ? ''
              : (item.mh3DocStatusDescr === 'Подписан')
                ? 'Обработан'
                : item.mh3DocStatusDescr}`,
            commonNumberMKM: `${item.qcId}/${item.cgId}/${item.actualPieceId}`,
            endCustomerName: `${(item.endCustomerName === null)
              ? item.customerName
              : item.endCustomerName}`,
            stornoFlag: item.stornoFlag === 'Y',
            onHoldFlag: item.onHoldFlag === 'Y',
            hasShippingPlan: item.hasShippingPlan === 'Y',
            wadat_ist: item.invoice ? item.dateOm : ''
          }))
        : response
    ));
  } catch (error) {
    yield put(errorModalOpen(error));
    yield put(actions.getIncomingFail(error));
  }
}

export function* incomingAccept({ payload }) {
  try {
    const response = yield call(post,
      '/action/incoming/accept/',
      {
        boxId: payload.boxId,
        items: payload.items,
        mh1: payload.mh1,
        plantId: payload.plantId,
        mh1Date: payload.mh1Date,
        internalIdRequestList: payload.internalIdRequestList
      });
    yield put(actions.getIncomingAcceptSuccess(response));
    // yield put(actions.getIncoming({ plantId: payload.plantId }));
  } catch (error) {
    yield put(errorModalOpen(error));
    yield put(actions.getIncomingAcceptFail(error.response.data));
  }
}

export function* incomingReject({ payload }) {
  try {
    const response = yield call(post,
      '/action/incoming/reject/',
      {
        items: payload.items,
        note: payload.note,
        plantId: payload.plantId
      });
    yield put(actions.getIncomingRejectSuccess(response));
    // yield put(actions.getIncoming({ plantId: payload.plantId }));
  } catch (error) {
    yield put(errorModalOpen(error));
    yield put(actions.getIncomingRejectFail(error.response.data));
  }
}

export function* incomingListAreas({ payload }) {
  try {
    const response = yield call(get,
      `/grid/list/areas/?plantId=${payload.plantId}&stockId=${payload.stockId}`);
    yield put(actions.getIncomingListAreasSuccess(response));
    if (response.length) {
      yield put(actions.getIncomingListBoxes({
        plantId: payload.plantId,
        areaId: response[0].stockConfigNumId
      }));
    }
  } catch (error) {
    yield put(errorModalOpen(error));
    yield put(actions.getIncomingListAreasFail(error));
  }
}

export function* incomingListBoxes({ payload }) {
  try {
    const response = yield call(get,
      `/grid/list/boxes/?areaId=${payload.areaId}&plantId=${payload.plantId}`);
    yield put(actions.getIncomingListBoxesSuccess(response));
  } catch (error) {
    yield put(errorModalOpen(error));
    yield put(actions.getIncomingListBoxesFail(error));
  }
}

export function* incomingListStocks({ payload }) {
  try {
    const response = yield call(get,
      `/grid/list/stocks/?plantId=${payload.plantId}`);
    yield put(actions.getIncomingListStocksSuccess(response));
    if (response.length) {
      yield put(actions.getIncomingListAreas({
        plantId: payload.plantId,
        stockId: response[0].stockConfigNumId
      }));
    }
  } catch (error) {
    yield put(errorModalOpen(error));
    yield put(actions.getIncomingListStocksFail(error));
  }
}
